import React, {ReactElement, useMemo} from 'react';
import {add, sub, format} from "date-fns"
import CalendrierEnteteDate from "./calendrier-entete-date";
import {fr} from "date-fns/locale";
import {useCalendrierProps} from "./calendrier";
import {TypeCalendrier} from './calendrier-interfaces';

const dateCourrant = (date: number | Date, showMonth: Boolean = false) => {
    return <div>
    <span style={{overflow: "hidden", textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
      {format(date, "yyyy", {locale: fr})}
    </span>
        <br/>
        {showMonth && format(date, "MMMMMM", {locale: fr})}
    </div>
}

const isSelected = (colonne: number, selectedCell: any) => {
    if (selectedCell?.selectedCell.length) {
        for (let y = 0; y < selectedCell.selectedCell.length; y++) {
            if (selectedCell.selectedCell[y].colonne == colonne) return true
        }
    }
    return false;
};

// const isSelectedDate = (d: Date) => {
//   if (selectedCell?.selectedCell.length) {
//     for (let y = 0; y < selectedCell.selectedCell.length; y++) {
//       for (let i = 0; i < selectedCell.selectedCell[y].dates.length; i++) {
//         if (selectedCell.selectedCell[y].dates[i].getTime() == d.getTime()) return true
//       }
//     }
//   }
//   return false;
// };

const CalendrierEntete = (selectedCell: any) => {
    const {dateCourrante, dateCourranteFin, nbColonne, typeCalendrier, selectedTypeUnite, calendrierData} = useCalendrierProps()
    document.documentElement.style.setProperty("--nbColonneDate", nbColonne.toString());
    document.documentElement.style.setProperty("--colonneSize", selectedTypeUnite?.tailleColonne || "0");

    const renderDate = useMemo(() => {
        if (!selectedTypeUnite?.calDateDebut) {
            return new Array(nbColonne).fill({}).map((_, i) => {
                const date = add(dateCourrante, {[typeCalendrier === TypeCalendrier.Jours ? "days" : "months"]: i});
                return <CalendrierEnteteDate key={`cell-entete-${i}`} date={date} isSelected={selectedCell?.selectedCell.length && isSelected(i, selectedCell)}/>
            });
        }
        const arr: ReactElement[] = [];
        let duree = 1;

        function checkSiDuree(object: ReactElement) {
            if (selectedTypeUnite && selectedTypeUnite?.dureePeriode !== 1) {
                if (duree == selectedTypeUnite.dureePeriode)
                    duree = 1;
                else {
                    arr.push(object);
                    duree++;
                }
            } else
                arr.push(object);
        }

        if (dateCourrante && nbColonne && typeCalendrier
            && selectedTypeUnite && selectedTypeUnite?.calDateDebut
            && selectedTypeUnite?.calDateFin &&
            selectedTypeUnite?.calDateDebut instanceof Date &&
            selectedTypeUnite?.calDateFin instanceof Date) {
            const calDateDebut = new Date(dateCourrante.getFullYear(), selectedTypeUnite.calDateDebut.getMonth(), selectedTypeUnite.calDateDebut.getDate())
            const calDateFin = new Date(dateCourrante.getFullYear(), selectedTypeUnite.calDateFin.getMonth(), selectedTypeUnite.calDateFin.getDate());

            if (calDateDebut > calDateFin) {
                calDateDebut.setFullYear(calDateDebut.getFullYear() - 1);
            }
            let dateDebut = dateCourrante;
            for (let i = 0; arr.length < nbColonne; i++) {
                let date = add(dateDebut, {[typeCalendrier === TypeCalendrier.Jours ? "days" : "months"]: i});

                const object = <CalendrierEnteteDate key={`cell-entete-${i}`} date={date} isSelected={selectedCell?.selectedCell.length && isSelected(arr.length, selectedCell)}/>
                if (typeCalendrier === TypeCalendrier.Mois) {
                    if (!selectedTypeUnite?.calDateDebut) {
                        arr.push(object);
                    } else if (
                        (date.getMonth() >= selectedTypeUnite.calDateDebut.getMonth() && date.getMonth() <= selectedTypeUnite.calDateFin.getMonth()) ||
                        (selectedTypeUnite.calDateFin < selectedTypeUnite.calDateDebut && (date.getMonth() >= selectedTypeUnite.calDateDebut.getMonth() ||
                            date.getMonth() <= selectedTypeUnite.calDateFin.getMonth()))
                    ) {
                        checkSiDuree(object);
                    }
                    // else
                    //   arr.push(object);
                } else if (typeCalendrier === TypeCalendrier.Jours) {
                    if (date >= calDateDebut && date <= calDateFin) {
                        checkSiDuree(object);
                    }
                } else
                    arr.push(object);

                if (date >= calDateFin) {
                    calDateDebut.setFullYear(calDateDebut.getFullYear() + 1);
                    calDateFin.setFullYear(calDateFin.getFullYear() + 1);
                    dateDebut = sub(calDateDebut, {[typeCalendrier === TypeCalendrier.Jours ? "days" : "months"]: i + 1})
                }
            }
        }
        return arr
    }, [nbColonne, dateCourrante, typeCalendrier, selectedCell, selectedTypeUnite]);

    const renderMonth = useMemo(() => {
        const dates: ReactElement[] = [];
        const elements: { date: Date, year: number, month: number, nbColonne: number }[] = [
            {
                "date": renderDate[0]?.props.date,
                "year": renderDate[0]?.props.date.getYear(),
                "month": renderDate[0]?.props.date.getMonth(),
                "nbColonne": 1
            },
        ];
        for (let i = 1; i <= renderDate.length; i++) {
            const date = renderDate[i]?.props.date;
            if (date) {
                let isFound;
                for (let y = 0; y <= elements.length; y++) {
                    if (typeCalendrier === TypeCalendrier.Jours &&
                        elements[y]?.month == date.getMonth()) {
                        isFound = true;
                        elements[y].nbColonne++;
                        break;
                    } else if (typeCalendrier === TypeCalendrier.Mois &&
                        elements[y]?.year == date.getYear()) {
                        isFound = true;
                        elements[y].nbColonne++;
                        break;
                    }
                }
                if (!isFound) {
                    elements.push({
                        "date": date,
                        "year": date.getYear(),
                        "month": date.getMonth(),
                        "nbColonne": 1
                    })
                }
            }
        }

        if (elements.length === 1 && elements[0].date) {
            return <div className={"entete mois"}
                        style={{
                            gridColumnStart: 3,
                            gridColumnEnd: 3 + nbColonne
                        }}>
                {dateCourrant(elements[0].date, typeCalendrier === TypeCalendrier.Jours)}
            </div>
        } else {
            for (let i = 0; i <= elements.length; i++) {
                if (elements[i]?.date) {
                    let concatColonnes = 0;
                    elements.forEach(e => {
                        concatColonnes += e.nbColonne;
                    });

                    let nextColonnes = 0;
                    for (let x = 0; x < i; x++) {
                        nextColonnes += elements[x].nbColonne;
                    }

                    let previousColonnes = 0;
                    for (let x = 0; x <= i; x++) {
                        previousColonnes += elements[x].nbColonne;
                    }

                    const gridColumnStart = i !== 0
                        ? 3 + nextColonnes
                        : 3;

                    const gridColumnEnd = 3 + (i !== 0
                        ? previousColonnes
                        // ? elements[i - 1].nbColonne + elements[i].nbColonne
                        : elements[i].nbColonne);

                    dates.push(
                        <div
                            key={i}
                            className="entete mois"
                            style={{
                                gridColumnStart,
                                gridColumnEnd,
                            }}
                        >
                            {dateCourrant(elements[i].date, typeCalendrier === TypeCalendrier.Jours)}
                        </div>
                    );
                }
            }
            return dates;
        }
    }, [nbColonne, typeCalendrier, renderDate]);

    return (
        <>
            <div className="entete unite"> Unité</div>
            <div className="entete nbpersonne">P</div>
            {renderMonth}
            {renderDate}
        </>
    );
}
export default CalendrierEntete;